import React, { useContext } from "react";
import { Icon, Grid } from "semantic-ui-react";
import { ButtonLink, ClippedContent, DateTimeUtils } from "dyl-components";
import { QuoteBuilderContext } from "shared/context/QuoteBuilderProvider";
import { useSelector } from "react-redux";
import { StringUtils } from "utils";

const CustomerRecentOrder = ({ textAlign = "right" }) => {
    const { onViewInvoice } = useContext(QuoteBuilderContext);
    const recentOrder = useSelector((state) => {
        const recentOrder = state.order.recentOrder;
        const price_schedule = state.account.account?.account_term?.price_schedule;
        return recentOrder?.order_id
            ? {
                  account_term: price_schedule,
                  one_time_amount: `$${StringUtils.formatDecimal(
                      `${recentOrder.subtotal || 0}`,
                      true
                  )}`,
                  recurring_amount: `$${StringUtils.formatDecimal(
                      `${state.subscription.next_invoice?.[price_schedule]?.total || 0}`,
                      true
                  )}`,
                  subtotal: `$${StringUtils.formatDecimal(
                      `${recentOrder.subtotal || 0}`,
                      true
                  )}`,
                  order_status: StringUtils.capitalize(recentOrder.order_status),
                  order_date: DateTimeUtils.changeFormat(
                      DateTimeUtils.convertUnixTimeToDate(
                          recentOrder.order_date,
                          "UTC"
                      ),
                      "",
                      DateTimeUtils.DATE_FORMAT,
                      "UTC"
                  ),
                  invoice_date: recentOrder?.invoice_date ? DateTimeUtils.changeFormat(
                      DateTimeUtils.convertUnixTimeToDate(
                          recentOrder.invoice_date,
                          "UTC"
                      ),
                      "",
                      DateTimeUtils.DATE_FORMAT,
                      "UTC"
                  ) : "None",
                  invoice_id: recentOrder?.invoice_id,
              }
            : {
                  one_time_amount: "None",
                  recurring_amount: "None",
                  subtotal: "None",
                  order_status: "None",
                  order_date: "None",
                  invoice_date: "None",
              };
    });

    return (
        <Grid className="RecordInfo">
            <Grid.Row columns="equal" verticalAlign="middle">
                <Grid.Column><b>Current Invoice</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    <div className="CurrentInvoiceColumn">
                        {Boolean(recentOrder?.invoice_id) ? (
                            <Grid>
                                <Grid.Row columns="equal" verticalAlign="middle">
                                    <Grid.Column textAlign="right">
                                        <ClippedContent>
                                            <ButtonLink
                                                className="CurrentInvoiceValue"
                                                noPadding
                                                onClick={() => {
                                                    onViewInvoice(
                                                        recentOrder?.invoice_id
                                                    );
                                                }}
                                            >

                                                {recentOrder?.invoice_id}
                                            </ButtonLink>
                                        </ClippedContent>
                                    </Grid.Column>
                                    <Grid.Column textAlign="right">
                                        <Icon
                                            link
                                            className="fas fa-copy"
                                            onClick={StringUtils.copy(
                                                recentOrder.invoice_id
                                            )}
                                            color="primary"
                                        />
                                        <Icon
                                            onClick={() => {
                                                onViewInvoice(
                                                    recentOrder?.invoice_id
                                                );
                                            }}
                                            className="fas fa-file-pdf"
                                            link
                                            color="primary"
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        ) : (
                            "None"
                        )}
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>One-Time Amount</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.one_time_amount}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Recurring Amount</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.recurring_amount}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Subtotal</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.subtotal}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Order Status</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.order_status}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Order Date</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.order_date}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Next Invoice Date</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {recentOrder.invoice_date}
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns="equal">
                <Grid.Column><b>Billed</b></Grid.Column>
                <Grid.Column textAlign={textAlign}>
                    {StringUtils.capitalize(recentOrder?.account_term || "None")}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default CustomerRecentOrder;
